<template>
  <v-dialog :value="true" max-width="400">
    <v-card>
      <v-card-title class="headline">{{ ((id) ? 'Editar' : 'Adicionar') + ' Renegociação' }}</v-card-title>
      <v-card-text class="pt-4">
        <v-alert type="error" v-if="errorMessage" class="mb-6">{{ errorMessage }}</v-alert>
        <v-form ref="form" @submit.prevent>
          <v-autocomplete
            label="Categoria *"
            v-model="fields.category.value"
            :rules="[...fields.category.rules, ...fields.category.apiErrors]"
            :items="fields.category.options"
            @input="fields.category.apiErrors = []; concatDescription()"
            outlined dense
          ></v-autocomplete>
          <v-autocomplete
            label="Arrecadação *"
            v-model="fields.joined_id.value"
            :rules="[...fields.joined_id.rules, ...fields.joined_id.apiErrors]"
            :items="joineds"
            @input="fields.joined_id.apiErrors = []; concatDescription()"
            outlined dense
          ></v-autocomplete>
          <v-text-field
            label="Descrição *"
            v-model="fields.description.value"
            :rules="[...fields.description.rules, ...fields.description.apiErrors]"
            type="text"
            @input="fields.description.apiErrors = []"
            outlined dense
          ></v-text-field>
          <v-autocomplete
            label="Competência *"
            v-model="fields.due_date.value"
            :rules="[...fields.due_date.rules, ...fields.due_date.apiErrors]"
            :items="dateItems"
            @input="fields.due_date.apiErrors = []; concatDescription()"
            outlined dense
          ></v-autocomplete>
          <decimal-number
            label="Valor *"
            v-model="fields.installment_amount.value"
            :rules="[...fields.installment_amount.apiErrors]"
            @input="fields.installment_amount.apiErrors = []"
            outlined dense
          ></decimal-number>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="default" :disabled="saving" text @click="$emit('canceled')">
          Cancelar
        </v-btn>
        <v-btn color="success" :disabled="saving" :loading="saving" text @click="saveItem()">
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios'
import { mapMutations } from 'vuex'
import DecimalNumber from '@/components/DecimalNumber'

export default {
  name: 'editRenegotiation',
  components: {
    DecimalNumber
  },
  props: {
    item: {
      required: false,
      type: Object
    },
    joineds: {
      required: true,
      type: Array
    },
    allowedDates: {
      required: true,
      type: Object
    },
    id: {
      required: false,
      type: [String, Number]
    }
  },
  data: () => ({
    saving: false,
    fields: {
      category: {
        value: '',
        options: [
          { value: 'interest_and_fines', text: 'Multa/juros' },
          { value: 'renegotiation', text: 'Renegociação' },
          { value: 'additional', text: 'Adicional' },
          { value: 'discount', text: 'Desconto' }
        ],
        rules: [
          v => !!v || 'A categoria é obrigatória'
        ],
        apiErrors: []
      },
      joined_id: {
        value: '',
        options: [],
        rules: [
          v => !!v || 'A arrecadação é obrigatória'
        ],
        apiErrors: []
      },
      description: {
        value: '',
        rules: [
          v => !!v || 'A descrição é obrigatória'
        ],
        apiErrors: []
      },
      installment: {
        value: 1,
        rules: [
          v => !!v || 'A indicação da parcela é obrigatória'
        ],
        apiErrors: []
      },
      installment_amount: {
        value: 0,
        rules: [
          v => !!v || 'O valor é obrigatório'
        ],
        apiErrors: []
      },
      due_date: {
        value: null,
        rules: [
          v => !!v || 'A data de vencimento é obrigatória'
        ],
        apiErrors: []
      }
    },
    errorMessage: null
  }),
  computed: {
    apiData () {
      let data = {}
      for (let key in this.fields) {
        if (this.fields[key].value) data[key] = this.fields[key].value
      }
      return data
    },
    dateItems () {
      const monthList = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']
      const items = []
      if (this.fields.joined_id.value && this.allowedDates[this.fields.joined_id.value] && this.allowedDates[this.fields.joined_id.value].length > 1) {
        for (let i = 1; i < this.allowedDates[this.fields.joined_id.value].length; i++) {
          const date = this.allowedDates[this.fields.joined_id.value][i]
          items.push({ value: date.value, text: monthList[date.month - 1] + ' ' + date.year })
        }
      }
      return items
    }
  },
  methods: {
    ...mapMutations(['SET_SNACKBAR']),
    generateApiErrors (apiErrors) {
      for (let key in apiErrors) {
        if (this.fields[key]) this.fields[key].apiErrors = apiErrors[key]
      }
    },
    concatDescription () {
      let description = ''
      if (this.fields.category.value) description += this.fields.category.options.filter(e => { return e.value === this.fields.category.value })[0].text + ' - '
      if (this.fields.joined_id.value) description += this.joineds.filter(e => { return e.value === this.fields.joined_id.value })[0].text + ' - '
      this.fields.description.value = description
    },
    saveItem () {
      let vue = this
      vue.saving = true

      let endpoint = (vue.id) ? 'financial-negotiations/' + vue.id : 'financial-negotiations'

      axios(endpoint, {
        method: (vue.id) ? 'patch' : 'post',
        data: vue.apiData
      })
        .then(response => {
          vue.saving = false
          vue.SET_SNACKBAR({ text: 'Forma de pagamento editada' })
          vue.$emit('edited')
        })
        .catch(() => {
          vue.SET_SNACKBAR({ text: 'Houve um erro ao processar seu pedido, por favor tente novamente' })
          vue.saving = false
          vue.$emit('error')
        })
    }
  },
  watch: {
    item: {
      handler (value) {
        let vue = this

        if (vue.item) {
          for (let key in vue.fields) {
            if (vue.item[key]) vue.fields[key].value = vue.item[key]
          }
        } else {
          vue.SET_SNACKBAR({ text: 'Houve um erro ao processar seu pedido. Tente novamente.' })
          vue.$emit('error')
        }
      },
      deep: true
    }
  },
  created () {
    let vue = this

    if (vue.joineds && vue.id && vue.item) {
      for (let key in vue.fields) {
        if (vue.item[key]) vue.fields[key].value = vue.item[key]
      }
    } else {
      vue.SET_SNACKBAR({ text: 'Houve um erro ao processar seu pedido. Tente novamente.' })
      vue.$emit('error')
    }
  }
}
</script>
